import "./FooterBotanical.css";

import FooterBotanicalRight from "../../svg/FooterBotanicalRight.jsx";
import FooterBotanicalLeft from "../../svg/FooterBotanicalLeft.jsx";

export default function FooterBotanical() {
  return (
    <>
      <FooterBotanicalLeft />
      <FooterBotanicalRight />
    </>
  );
}